<template lang="pug">

  .lesson-test-slide
    .lesson-test-slide__intervals
      Interval(
        v-for="(interval, iIdx) in results" :key="interval.intervalDeleteId"
        :idx="iIdx"
        :propInterval="interval"
        :propData="interval"
        :resultsLength="results.length"
        @deleteInterval="deleteInterval(iIdx)"
        @addInterval="addInterval(iIdx)"
        @updateInterval="updateInterval($event, iIdx)"
      )

</template>

<script>
import _ from 'lodash';
import Interval from './Interval';

export default {
  components: {
    Interval
  },
  props: ['propData', 'currentSlideIdx', 'idx'],
  data: () => ({
    results: [],
    intervalDeleteId: 0,
    intervalsToDelete: [],
    emptyInterval: {
      id: '',
      isDeleted: false,
      position: 0,
      pointsFrom: 0,
      pointsTo: 0,
      text: 'Новый интервал',
      img: {}
    }
  }),
  watch: {
    currentSlideIdx(val) {
      if (val === this.idx) {
        this.setNavText();
      }
    }
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      this.results = _.cloneDeep(this.propData).map(interval => {
        this.intervalDeleteId++;
        interval.intervalDeleteId = this.intervalDeleteId;
        return interval;
      });

      if (this.idx === this.currentSlideIdx) {
        this.setNavText();
      }
    },
    setNavText() {
      this.$emit('update:navText', 'Завершение');
    },
    deleteInterval(idx) {
      if (this.results.length > 1) {
        this.results[idx].isDeleted = true;
        if (this.results[idx].id) {
          this.intervalsToDelete.push(this.results[idx]);
          this.$emit('updateIntervalsToDelete', this.intervalsToDelete);
        }

        this.results = this.results.filter(interval => !interval.isDeleted);

        this.updateResults();
      }
    },
    updateInterval(interval, idx) {
      this.results[idx] = _.cloneDeep(interval);

      this.updateResults();
    },
    addInterval(idx) {
      const newInterval = _.cloneDeep(this.emptyInterval);
      this.intervalDeleteId++;
      newInterval.intervalDeleteId = this.intervalDeleteId;

      this.results.splice(idx + 1, 0, newInterval);

      this.updateResults();
    },
    updateResults() {
      this.$emit('updateResults', this.results);
    }
  }
};
</script>
